import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RequestStrategyEnum, StatementsApi, type WithSignal, type StatementsRequest, type StatementsResponse } from '@shared/api';

const getStatementsEffect = createEffect(({ signal, ...request }: WithSignal<StatementsRequest> = {}) =>
  StatementsApi.getStatements(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ data: StatementsResponse[]; total: number }>({ data: [], total: 0 })
  .on(getStatementsEffect.done, (current, data) => (data.result ? { data: data.result.data || [], total: data.result.total } : current))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getStatementsEffect.pending, (_, data) => data)
  .on(getStatementsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getStatementsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getStatementsEffect, () => null)
  // .on(getStatementsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getStatementsEffect.fail, () => 'Something went wrong while fetching Statement. Please try again.')
  .on(getStatementsEffect.done, () => null)
  .reset(clearEvent);

const getStatementsApi = ApiUtils.wrapperApi(getStatementsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getStatementsApi.cancel());

export const $statementsStore = {
  events: {
    getStatements: getStatementsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
